const vars = {
    path: ''
};

export default vars